import { colors } from '@components/design-system';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    subMenuBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '50px',
        width: '100%',
        backgroundColor: `${colors.neutral[50]}`,
        borderBottom: '1px solid #E5E7EB',
        padding: '0 24px',
        boxSizing: 'border-box',
        flexShrink: 0,
        '& span': {
            margin: '0 10px',
            fontSize: '14px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '0 12px',
        },
    },
    logo: {
        width: '120px',

        [theme.breakpoints.down('md')]: {
            width: '80px',
        },
    },
    logoSidebar: {
        width: '70%',
    },
}));
